/* tslint:disable */
/* eslint-disable */
import { AbschnittDisplayModel as AceXFoundPortalCoreCaqModelsAbschnittDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/abschnitt-display-model';
import { DocumenttypeDisplayModel as AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/documenttype-display-model';
import { LocalizedLinkDisplayModel as AceXFoundPortalCoreCaqModelsLocalizedLinkDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/localized-link-display-model';
import { LocalizedTextDisplayModel as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/localized-text-display-model';
import { GlobalEnumsAceAntragsteller as AceXFoundPortalCoreEntitiesGlobalEnumsAceAntragsteller } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-antragsteller';
import { GlobalEnumsAceJaNein as AceXFoundPortalCoreEntitiesGlobalEnumsAceJaNein } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-ja-nein';
import { GlobalEnumsAceMittelabruf as AceXFoundPortalCoreEntitiesGlobalEnumsAceMittelabruf } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-mittelabruf';
import { GlobalEnumsAceMittelabrufzahlung as AceXFoundPortalCoreEntitiesGlobalEnumsAceMittelabrufzahlung } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-mittelabrufzahlung';
import { GlobalEnumsAcePortalsprache as AceXFoundPortalCoreEntitiesGlobalEnumsAcePortalsprache } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-portalsprache';
import { GlobalEnumsAcePortaltyp as AceXFoundPortalCoreEntitiesGlobalEnumsAcePortaltyp } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-portaltyp';
import { GlobalEnumsAceSortierungausschreibungskacheln as AceXFoundPortalCoreEntitiesGlobalEnumsAceSortierungausschreibungskacheln } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-sortierungausschreibungskacheln';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { AbschnittDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsAbschnittDisplayModelFormGroup } from '@/api/model-index';
import { DocumenttypeDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModelFormGroup } from '@/api/model-index';
import { LocalizedLinkDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsLocalizedLinkDisplayModelFormGroup } from '@/api/model-index';
import { LocalizedTextDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup } from '@/api/model-index';

export interface IPortalkonfigurationDisplayModel {
  absendenEinwilligungserklaerung?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  absendenUeberschrift?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  absenderNachrichten?: null | string;
  anfrageArt?: null | number;
  antragstellerArt?: AceXFoundPortalCoreEntitiesGlobalEnumsAceAntragsteller;
  artDesMittelabrufs?: AceXFoundPortalCoreEntitiesGlobalEnumsAceMittelabruf;
  befangenheitsdialog?: AceXFoundPortalCoreEntitiesGlobalEnumsAceJaNein;
  bestaetigunstextVorAbsenden?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  datenschutzbestimmungen?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedLinkDisplayModel>;
  datenschutzerklaerungen?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  erfolgreichAbgesendetTexte?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  freigabeDeaktivieren?: AceXFoundPortalCoreEntitiesGlobalEnumsAceJaNein;
  fristMittelabrufAb?: null | number;
  fristMittelabrufBis?: null | number;
  ibanueberpruefung?: null | boolean;
  impressen?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedLinkDisplayModel>;
  infotexteGutachter?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  infotexteInSidebarAnzeigen?: null | boolean;
  infotexteMeineProjekte?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  infotexteMeineProjektideen?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  infotexteUebersicht?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  maxFileSizeMB?: null | number;
  maxFileSizePerAntragMB?: null | number;
  mittelabrufAbschnitt?: AceXFoundPortalCoreCaqModelsAbschnittDisplayModel;
  mittelabrufDokumententyp?: AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel;
  mittelabrufText?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  mittelabrufZahlung?: AceXFoundPortalCoreEntitiesGlobalEnumsAceMittelabrufzahlung;
  nachrichtenInSidebarAnzeigen?: null | boolean;
  portalSprache?: AceXFoundPortalCoreEntitiesGlobalEnumsAcePortalsprache;
  portalTyp?: AceXFoundPortalCoreEntitiesGlobalEnumsAcePortaltyp;
  projekteAnzeigen?: null | boolean;
  projektideenAnzeigen?: null | boolean;
  registrationIsDisabled?: boolean;
  sortierungAusschreibungskacheln?: AceXFoundPortalCoreEntitiesGlobalEnumsAceSortierungausschreibungskacheln;
  useAusschreibungen?: null | boolean;
  validierungsubersichtInSidebarAnzeigen?: null | boolean;
  version?: null | string;
  willkommenstexte?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  willkommenstexteGutachter?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  zurueckziehenDeaktivieren?: boolean;
}
export class PortalkonfigurationDisplayModel extends BaseModel implements IPortalkonfigurationDisplayModel {
  absendenEinwilligungserklaerung?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  absendenUeberschrift?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  absenderNachrichten?: null | string;
  anfrageArt?: null | number;
  antragstellerArt?: AceXFoundPortalCoreEntitiesGlobalEnumsAceAntragsteller;
  artDesMittelabrufs?: AceXFoundPortalCoreEntitiesGlobalEnumsAceMittelabruf;
  befangenheitsdialog?: AceXFoundPortalCoreEntitiesGlobalEnumsAceJaNein;
  bestaetigunstextVorAbsenden?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  datenschutzbestimmungen?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedLinkDisplayModel>;
  datenschutzerklaerungen?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  erfolgreichAbgesendetTexte?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  freigabeDeaktivieren?: AceXFoundPortalCoreEntitiesGlobalEnumsAceJaNein;
  fristMittelabrufAb?: null | number;
  fristMittelabrufBis?: null | number;
  ibanueberpruefung?: null | boolean;
  impressen?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedLinkDisplayModel>;
  infotexteGutachter?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  infotexteInSidebarAnzeigen?: null | boolean;
  infotexteMeineProjekte?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  infotexteMeineProjektideen?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  infotexteUebersicht?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  maxFileSizeMB?: null | number;
  maxFileSizePerAntragMB?: null | number;
  mittelabrufAbschnitt?: AceXFoundPortalCoreCaqModelsAbschnittDisplayModel;
  mittelabrufDokumententyp?: AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel;
  mittelabrufText?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  mittelabrufZahlung?: AceXFoundPortalCoreEntitiesGlobalEnumsAceMittelabrufzahlung;
  nachrichtenInSidebarAnzeigen?: null | boolean;
  portalSprache?: AceXFoundPortalCoreEntitiesGlobalEnumsAcePortalsprache;
  portalTyp?: AceXFoundPortalCoreEntitiesGlobalEnumsAcePortaltyp;
  projekteAnzeigen?: null | boolean;
  projektideenAnzeigen?: null | boolean;
  registrationIsDisabled?: boolean;
  sortierungAusschreibungskacheln?: AceXFoundPortalCoreEntitiesGlobalEnumsAceSortierungausschreibungskacheln;
  useAusschreibungen?: null | boolean;
  validierungsubersichtInSidebarAnzeigen?: null | boolean;
  version?: null | string;
  willkommenstexte?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  willkommenstexteGutachter?: null | Array<AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModel>;
  zurueckziehenDeaktivieren?: boolean;
}
class BasePortalkonfigurationDisplayModelFormGroup extends FormGroup {
  private static _instance: PortalkonfigurationDisplayModelFormGroup;
  
  public static get Instance(): PortalkonfigurationDisplayModelFormGroup {
    this._instance = new PortalkonfigurationDisplayModelFormGroup({
      absendenEinwilligungserklaerung: new FormArray([]),
      absendenUeberschrift: new FormArray([]),
      absenderNachrichten: new FormControl(null),
      anfrageArt: new FormControl(null),
      antragstellerArt: new FormControl(null),
      artDesMittelabrufs: new FormControl(null),
      befangenheitsdialog: new FormControl(null),
      bestaetigunstextVorAbsenden: new FormArray([]),
      datenschutzbestimmungen: new FormArray([]),
      datenschutzerklaerungen: new FormArray([]),
      erfolgreichAbgesendetTexte: new FormArray([]),
      freigabeDeaktivieren: new FormControl(null),
      fristMittelabrufAb: new FormControl(null),
      fristMittelabrufBis: new FormControl(null),
      ibanueberpruefung: new FormControl(null),
      impressen: new FormArray([]),
      infotexteGutachter: new FormArray([]),
      infotexteInSidebarAnzeigen: new FormControl(null),
      infotexteMeineProjekte: new FormArray([]),
      infotexteMeineProjektideen: new FormArray([]),
      infotexteUebersicht: new FormArray([]),
      maxFileSizeMB: new FormControl(null),
      maxFileSizePerAntragMB: new FormControl(null),
      mittelabrufAbschnitt: AceXFoundPortalCoreCaqModelsAbschnittDisplayModelFormGroup.Instance,
      mittelabrufDokumententyp: AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModelFormGroup.Instance,
      mittelabrufText: new FormArray([]),
      mittelabrufZahlung: new FormControl(null),
      nachrichtenInSidebarAnzeigen: new FormControl(null),
      portalSprache: new FormControl(null),
      portalTyp: new FormControl(null),
      projekteAnzeigen: new FormControl(null),
      projektideenAnzeigen: new FormControl(null),
      registrationIsDisabled: new FormControl(null),
      sortierungAusschreibungskacheln: new FormControl(null),
      useAusschreibungen: new FormControl(null),
      validierungsubersichtInSidebarAnzeigen: new FormControl(null),
      version: new FormControl(null),
      willkommenstexte: new FormArray([]),
      willkommenstexteGutachter: new FormArray([]),
      zurueckziehenDeaktivieren: new FormControl(null),
    });

    return this._instance;
  }
}


export class PortalkonfigurationDisplayModelFormGroup extends BasePortalkonfigurationDisplayModelFormGroup {
  public get AbsendenEinwilligungserklaerung(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["absendenEinwilligungserklaerung"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get AbsendenUeberschrift(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["absendenUeberschrift"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get AbsenderNachrichten(): FormControl {
    return this.controls["absenderNachrichten"] as FormControl;
  }
  public get AnfrageArt(): FormControl {
    return this.controls["anfrageArt"] as FormControl;
  }
  public get AntragstellerArt(): FormControl {
    return this.controls["antragstellerArt"] as FormControl;
  }
  public get ArtDesMittelabrufs(): FormControl {
    return this.controls["artDesMittelabrufs"] as FormControl;
  }
  public get Befangenheitsdialog(): FormControl {
    return this.controls["befangenheitsdialog"] as FormControl;
  }
  public get BestaetigunstextVorAbsenden(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["bestaetigunstextVorAbsenden"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get Datenschutzbestimmungen(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedLinkDisplayModelFormGroup> {
    return this.controls["datenschutzbestimmungen"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedLinkDisplayModelFormGroup>;
  }
  public get Datenschutzerklaerungen(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["datenschutzerklaerungen"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get ErfolgreichAbgesendetTexte(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["erfolgreichAbgesendetTexte"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get FreigabeDeaktivieren(): FormControl {
    return this.controls["freigabeDeaktivieren"] as FormControl;
  }
  public get FristMittelabrufAb(): FormControl {
    return this.controls["fristMittelabrufAb"] as FormControl;
  }
  public get FristMittelabrufBis(): FormControl {
    return this.controls["fristMittelabrufBis"] as FormControl;
  }
  public get Ibanueberpruefung(): FormControl {
    return this.controls["ibanueberpruefung"] as FormControl;
  }
  public get Impressen(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedLinkDisplayModelFormGroup> {
    return this.controls["impressen"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedLinkDisplayModelFormGroup>;
  }
  public get InfotexteGutachter(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["infotexteGutachter"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get InfotexteInSidebarAnzeigen(): FormControl {
    return this.controls["infotexteInSidebarAnzeigen"] as FormControl;
  }
  public get InfotexteMeineProjekte(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["infotexteMeineProjekte"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get InfotexteMeineProjektideen(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["infotexteMeineProjektideen"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get InfotexteUebersicht(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["infotexteUebersicht"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get MaxFileSizeMB(): FormControl {
    return this.controls["maxFileSizeMB"] as FormControl;
  }
  public get MaxFileSizePerAntragMB(): FormControl {
    return this.controls["maxFileSizePerAntragMB"] as FormControl;
  }
  public get MittelabrufAbschnitt(): AceXFoundPortalCoreCaqModelsAbschnittDisplayModelFormGroup {
    return this.controls["mittelabrufAbschnitt"] as AceXFoundPortalCoreCaqModelsAbschnittDisplayModelFormGroup;
  }
  public get MittelabrufDokumententyp(): AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModelFormGroup {
    return this.controls["mittelabrufDokumententyp"] as AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModelFormGroup;
  }
  public get MittelabrufText(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["mittelabrufText"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get MittelabrufZahlung(): FormControl {
    return this.controls["mittelabrufZahlung"] as FormControl;
  }
  public get NachrichtenInSidebarAnzeigen(): FormControl {
    return this.controls["nachrichtenInSidebarAnzeigen"] as FormControl;
  }
  public get PortalSprache(): FormControl {
    return this.controls["portalSprache"] as FormControl;
  }
  public get PortalTyp(): FormControl {
    return this.controls["portalTyp"] as FormControl;
  }
  public get ProjekteAnzeigen(): FormControl {
    return this.controls["projekteAnzeigen"] as FormControl;
  }
  public get ProjektideenAnzeigen(): FormControl {
    return this.controls["projektideenAnzeigen"] as FormControl;
  }
  public get RegistrationIsDisabled(): FormControl {
    return this.controls["registrationIsDisabled"] as FormControl;
  }
  public get SortierungAusschreibungskacheln(): FormControl {
    return this.controls["sortierungAusschreibungskacheln"] as FormControl;
  }
  public get UseAusschreibungen(): FormControl {
    return this.controls["useAusschreibungen"] as FormControl;
  }
  public get ValidierungsubersichtInSidebarAnzeigen(): FormControl {
    return this.controls["validierungsubersichtInSidebarAnzeigen"] as FormControl;
  }
  public get Version(): FormControl {
    return this.controls["version"] as FormControl;
  }
  public get Willkommenstexte(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["willkommenstexte"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get WillkommenstexteGutachter(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup> {
    return this.controls["willkommenstexteGutachter"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsLocalizedTextDisplayModelFormGroup>;
  }
  public get ZurueckziehenDeaktivieren(): FormControl {
    return this.controls["zurueckziehenDeaktivieren"] as FormControl;
  }
  

}

export module PortalkonfigurationDisplayModelForm
  {
    export class FormFields
    {
      static _absendenEinwilligungserklaerung: string = "absendenEinwilligungserklaerung";
      static _absendenUeberschrift: string = "absendenUeberschrift";
      static _absenderNachrichten: string = "absenderNachrichten";
      static _anfrageArt: string = "anfrageArt";
      static _antragstellerArt: string = "antragstellerArt";
      static _artDesMittelabrufs: string = "artDesMittelabrufs";
      static _befangenheitsdialog: string = "befangenheitsdialog";
      static _bestaetigunstextVorAbsenden: string = "bestaetigunstextVorAbsenden";
      static _datenschutzbestimmungen: string = "datenschutzbestimmungen";
      static _datenschutzerklaerungen: string = "datenschutzerklaerungen";
      static _erfolgreichAbgesendetTexte: string = "erfolgreichAbgesendetTexte";
      static _freigabeDeaktivieren: string = "freigabeDeaktivieren";
      static _fristMittelabrufAb: string = "fristMittelabrufAb";
      static _fristMittelabrufBis: string = "fristMittelabrufBis";
      static _ibanueberpruefung: string = "ibanueberpruefung";
      static _impressen: string = "impressen";
      static _infotexteGutachter: string = "infotexteGutachter";
      static _infotexteInSidebarAnzeigen: string = "infotexteInSidebarAnzeigen";
      static _infotexteMeineProjekte: string = "infotexteMeineProjekte";
      static _infotexteMeineProjektideen: string = "infotexteMeineProjektideen";
      static _infotexteUebersicht: string = "infotexteUebersicht";
      static _maxFileSizeMB: string = "maxFileSizeMB";
      static _maxFileSizePerAntragMB: string = "maxFileSizePerAntragMB";
      static _mittelabrufAbschnitt: string = "mittelabrufAbschnitt";
      static _mittelabrufDokumententyp: string = "mittelabrufDokumententyp";
      static _mittelabrufText: string = "mittelabrufText";
      static _mittelabrufZahlung: string = "mittelabrufZahlung";
      static _nachrichtenInSidebarAnzeigen: string = "nachrichtenInSidebarAnzeigen";
      static _portalSprache: string = "portalSprache";
      static _portalTyp: string = "portalTyp";
      static _projekteAnzeigen: string = "projekteAnzeigen";
      static _projektideenAnzeigen: string = "projektideenAnzeigen";
      static _registrationIsDisabled: string = "registrationIsDisabled";
      static _sortierungAusschreibungskacheln: string = "sortierungAusschreibungskacheln";
      static _useAusschreibungen: string = "useAusschreibungen";
      static _validierungsubersichtInSidebarAnzeigen: string = "validierungsubersichtInSidebarAnzeigen";
      static _version: string = "version";
      static _willkommenstexte: string = "willkommenstexte";
      static _willkommenstexteGutachter: string = "willkommenstexteGutachter";
      static _zurueckziehenDeaktivieren: string = "zurueckziehenDeaktivieren";
    }
  }

